import React, { Component } from 'react';
import PropTypes from 'prop-types';

class BarLine extends Component {
  constructor(props) {
    super(props)
  }
  
  sizeBox(size) {
    let sum = 0;
    this.props.distribution.forEach(item => {
      sum += item[this.props.value];
    });
    if(sum==0) {
      return "0%";
    }
    const porc = (size / sum) * 100;
    return `${Math.round(porc)}%`;
  }

  render() {
    return (
      <div className="main_summary_graph__color_item_container">
        {this.props.distribution && this.props.distribution.map((item, i) => (
          <div
            key={`graph-${i}`}
            style={{ width: this.sizeBox(item[this.props.value]) }}
            className={`main_summary_graph__color_item_${item[this.props.name].toUpperCase()}`}
          >
            <div className="main_summary_graph__color_hover">
              <h6>
                {this.props.language[item[this.props.name].toUpperCase()]}
                <br/>
                <div className={`main_summary_graph__color_item_${item[this.props.name].toUpperCase()}`}>
                  {item[this.props.value] + " (" + this.sizeBox(item[this.props.value]) + ")"}
                </div>
              </h6>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default BarLine;



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/barLineNew.jsx